export default "__VITE_ASSET__Cg5058hZ__"